import { render, staticRenderFns } from "./InputRadio.vue?vue&type=template&id=136aef18&scoped=true&"
import script from "./InputRadio.vue?vue&type=script&lang=js&"
export * from "./InputRadio.vue?vue&type=script&lang=js&"
import style0 from "./InputRadio.vue?vue&type=style&index=0&id=136aef18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136aef18",
  null
  
)

export default component.exports